module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lists-overview"
  }, [(_vm.items.length > 0) ? _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.id,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.setCurrentList(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', {
      on: {
        "click": function($event) {
          _vm.removeItem(item.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(_vm._s(_vm.tileActionIcon))])], 1)], 1)
  }), 1) : _c('p', [_vm._v("Je hebt nog geen lijsten gemaakt. Maak een aan door op de plus rechts onderin te drukken.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cee48120","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/app/ListsOverview.vue
// module id = 496
// module chunks = 1